class l extends Promise {
  _pendingLabel;
  _fulfilledLabel;
  _rejectedLabel;
  constructor(e) {
    super((t, a) => {
      e(t, a);
    }), Object.setPrototypeOf(this, l.prototype);
  }
  get pendingLabel() {
    return this._pendingLabel;
  }
  set pendingLabel(e) {
    this._pendingLabel = e;
  }
  get fulfilledLabel() {
    return this._fulfilledLabel;
  }
  set fulfilledLabel(e) {
    this._fulfilledLabel = e;
  }
  get rejectedLabel() {
    return this._rejectedLabel;
  }
  set rejectedLabel(e) {
    this._rejectedLabel = e;
  }
}
export {
  l as default
};
//# sourceMappingURL=LabeledPromise.js.map
